import { render, staticRenderFns } from "./CodePopup.vue?vue&type=template&id=521b3d3a&scoped=true"
import script from "./CodePopup.vue?vue&type=script&lang=js"
export * from "./CodePopup.vue?vue&type=script&lang=js"
import style0 from "./CodePopup.vue?vue&type=style&index=0&id=521b3d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b3d3a",
  null
  
)

export default component.exports